(function(){
  if (window.__ptInit) return;   // guard: may be included by several sections
  window.__ptInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  (function(){
    if (reduce) return;
    var targets = document.querySelectorAll('.pt-section .pt-wrap > *, .pt-typecard, .pt-prob, .pt-band h2, .pt-band p, .pt-band .pt-btn, .pt-trust-item, .pt-timeline li, .pt-merch');
    if (!targets.length) return;
    targets.forEach(function(el){ el.classList.add('pt-reveal'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          var sib = Array.prototype.slice.call(e.target.parentNode.children);
          e.target.style.transitionDelay = Math.min(sib.indexOf(e.target) * 70, 350) + 'ms';
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, {threshold: 0.12, rootMargin: '0px 0px -40px 0px'});
    targets.forEach(function(el){ io.observe(el); });
  })();

  /* ---------- hero greens-up (fixed internal resolution, stretched by CSS) ---------- */
  document.querySelectorAll('[data-pt-hero-canvas]').forEach(function(cv){
    var ctx = cv.getContext('2d');
    var W = 1600, H = 760;
    cv.width = W; cv.height = H;
    var specks = [], blades = [], start = null, DUR = 1900, done = false;

    for (var i=0, n=Math.floor((W*H)/560); i<n; i++){
      var t = Math.random();
      specks.push({
        x:Math.random()*W, y:Math.random()*H, s:0.7+Math.random()*2.6,
        c: t<0.5 ? 'rgba(96,70,42,'+(0.20+Math.random()*0.30)+')'
          : t<0.8 ? 'rgba(26,18,9,'+(0.25+Math.random()*0.40)+')'
                  : 'rgba(206,184,132,'+(0.18+Math.random()*0.30)+')'
      });
    }
    for (var j=0, cnt=Math.floor(W/5); j<cnt; j++){
      blades.push({
        x:(j+Math.random()*0.6)*5, max:(H*0.42)+Math.random()*(H*0.52),
        w:1.6+Math.random()*3, delay:Math.random()*0.55,
        hue:86+Math.random()*26, light:24+Math.random()*20, lean:(Math.random()-0.5)*16
      });
    }
    function drawSoil(){
      var g = ctx.createLinearGradient(0,0,W*0.4,H);
      g.addColorStop(0,'#463525'); g.addColorStop(1,'#241a0f');
      ctx.fillStyle = g; ctx.fillRect(0,0,W,H);
      for (var i=0;i<specks.length;i++){ var s=specks[i]; ctx.fillStyle=s.c; ctx.fillRect(s.x,s.y,s.s,s.s); }
    }
    function drawBlades(p){
      for (var i=0;i<blades.length;i++){
        var b=blades[i], lp=(p-b.delay)/(1-b.delay); lp=lp<0?0:(lp>1?1:lp);
        var e=1-Math.pow(1-lp,3), h=b.max*e;
        if (h<1) continue;
        ctx.beginPath();
        ctx.moveTo(b.x,H);
        ctx.quadraticCurveTo(b.x+b.lean*0.4,H-h*0.6,b.x+b.lean,H-h);
        ctx.lineTo(b.x+b.lean+b.w,H-h+2);
        ctx.quadraticCurveTo(b.x+b.lean*0.4+b.w,H-h*0.6,b.x+b.w,H);
        ctx.closePath();
        ctx.fillStyle='hsl('+b.hue+',42%,'+b.light+'%)'; ctx.fill();
      }
    }
    function render(p){ drawSoil(); drawBlades(p); if(p>=1) done=true; }
    function frame(ts){ if(done) return; if(!start) start=ts; var p=Math.min(1,(ts-start)/DUR); render(p); if(p<1) requestAnimationFrame(frame); }
    render(0);
    if (reduce){ render(1); }
    else { requestAnimationFrame(frame); setTimeout(function(){ if(!done) render(1); }, DUR+250); }
  });

  /* ---------- hero parallax ---------- */
  (function(){
    if (reduce) return;
    var layers = document.querySelectorAll('[data-pt-parallax]');
    if (!layers.length) return;
    var ticking = false;
    function upd(){
      var y = window.scrollY || 0;
      layers.forEach(function(el){
        var sp = parseFloat(el.getAttribute('data-pt-parallax')) || 0.15;
        el.style.transform = 'translateY(' + (y * sp) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(upd); ticking = true; } }, {passive:true});
  })();

  /* ---------- before / after slider ---------- */
  document.querySelectorAll('[data-pt-ba]').forEach(function(ba){
    var before = ba.querySelector('.pt-ba-before');
    var handle = ba.querySelector('.pt-ba-handle');
    if (!before || !handle) return;
    var dragging = false, cur = 0.5;
    /* grabDX preserves the offset between the pointer and the handle so
       grabbing the grip off-centre does not teleport it (Apple: 1:1 drag
       must respect where the user grabbed). Clicking the bare image still
       jumps to the click, which is the expected scrubber behaviour. */
    var grabDX = 0;
    /* introDone cancels the scroll-in wipe the instant the user touches the
       slider. Without this the running rAF loop overwrites the drag every
       frame for up to 1.1s and the handle visibly fights the finger. */
    var introDone = false;

    function setPct(pct){
      cur = Math.max(0, Math.min(1, pct));
      before.style.clipPath = 'inset(0 ' + ((1-cur)*100) + '% 0 0)';
      handle.style.left = (cur*100) + '%';
      handle.setAttribute('aria-valuenow', Math.round(cur*100));
    }
    function setPos(clientX){
      var r = ba.getBoundingClientRect();
      if (!r.width) return;
      setPct((clientX + grabDX - r.left) / r.width);
    }
    ba.addEventListener('pointerdown', function(e){
      dragging = true;
      introDone = true;                 // user takes over from the intro
      ba.classList.add('is-dragging');
      var r = ba.getBoundingClientRect();
      var handleX = r.left + cur * r.width;
      var onHandle = handle.contains(e.target) || Math.abs(e.clientX - handleX) <= 26;
      grabDX = onHandle ? (handleX - e.clientX) : 0;
      setPos(e.clientX);
      try{ ba.setPointerCapture(e.pointerId); }catch(_){}
    });
    ba.addEventListener('pointermove', function(e){ if(dragging) setPos(e.clientX); });
    window.addEventListener('pointerup', function(){ dragging=false; grabDX=0; ba.classList.remove('is-dragging'); });
    ba.addEventListener('pointercancel', function(){ dragging=false; grabDX=0; ba.classList.remove('is-dragging'); });
    handle.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft'){ introDone = true; setPct(cur - 0.04); e.preventDefault(); }
      if (e.key === 'ArrowRight'){ introDone = true; setPct(cur + 0.04); e.preventDefault(); }
    });
    /* wipe-in: before layer sweeps from 0 to 50% the first time it scrolls into view */
    if (!reduce && typeof IntersectionObserver !== 'undefined'){
      setPct(0);
      var played = false;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting && !played){
            played = true; io.unobserve(ba);
            var t0 = null, DUR = 1100;
            function step(ts){
              if (introDone) return;    // interruptible: bail the moment the user grabs
              if (!t0) t0 = ts;
              var p = Math.min(1, (ts - t0) / DUR);
              setPct(0.5 * (1 - Math.pow(1 - p, 3)));
              if (p < 1) requestAnimationFrame(step); else introDone = true;
            }
            requestAnimationFrame(step);
          }
        });
      }, {threshold: 0.35});
      io.observe(ba);
    } else { setPct(0.5); introDone = true; }
  });

  /* ---------- painted before/after fallbacks (until real photos) ---------- */
  document.querySelectorAll('[data-pt-ba-paint]').forEach(function(cv){
    var mode = cv.getAttribute('data-pt-ba-paint');
    var ctx = cv.getContext('2d');
    var W = 1400, H = 700;
    cv.width = W; cv.height = H;
    var g = ctx.createLinearGradient(0, 0, 0, H);
    if (mode === 'before'){ g.addColorStop(0,'#57432B'); g.addColorStop(1,'#3A2C1A'); }
    else { g.addColorStop(0,'#2E4A22'); g.addColorStop(1,'#1B2E13'); }
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    for (var i=0, n=Math.floor((W*H)/700); i<n; i++){
      var t = Math.random();
      ctx.fillStyle = mode==='before'
        ? (t<0.5 ? 'rgba(96,70,42,.35)' : t<0.8 ? 'rgba(30,20,10,.4)' : 'rgba(180,150,100,.3)')
        : (t<0.5 ? 'rgba(20,40,14,.4)' : 'rgba(60,90,40,.3)');
      ctx.fillRect(Math.random()*W, Math.random()*H, 1+Math.random()*2.4, 1+Math.random()*2.4);
    }
    var count = mode==='before' ? Math.floor(W/26) : Math.floor(W/4);
    for (var j=0; j<count; j++){
      var x = Math.random()*W;
      var max = mode==='before' ? H*0.10+Math.random()*H*0.16 : H*0.34+Math.random()*H*0.5;
      var w = 1.4+Math.random()*2.6, lean = (Math.random()-0.5)*18;
      var hue = mode==='before' ? 62+Math.random()*24 : 88+Math.random()*24;
      var sat = mode==='before' ? 30 : 44;
      var light = mode==='before' ? 30+Math.random()*18 : 24+Math.random()*20;
      ctx.beginPath();
      ctx.moveTo(x, H);
      ctx.quadraticCurveTo(x+lean*0.4, H-max*0.6, x+lean, H-max);
      ctx.lineTo(x+lean+w, H-max+2);
      ctx.quadraticCurveTo(x+lean*0.4+w, H-max*0.6, x+w, H);
      ctx.closePath();
      ctx.fillStyle = 'hsl('+hue+','+sat+'%,'+light+'%)';
      ctx.fill();
    }
  });

  /* ---------- coverage calculator ---------- */
  document.querySelectorAll('[data-pt-calc]').forEach(function(root){
    var sqft = root.querySelector('[data-pt-sqft]');
    var seed = root.querySelector('[data-pt-seed]');
    var job  = root.querySelector('[data-pt-job]');
    var oBags = root.querySelector('[data-pt-bags]');
    var oLbl  = root.querySelector('[data-pt-lbl]');
    var oCost = root.querySelector('[data-pt-cost]');
    var oRow  = root.querySelector('[data-pt-bagrow]');
    if (!sqft || !seed) return;

    /* Reconcile the bag row instead of tearing it down. The old version did
       innerHTML='' on every keystroke, so typing "5000" rebuilt the whole row
       five times and restarted the stagger each character. Now only the
       difference is added or removed, and only genuinely new bags animate. */
    function syncBags(bags){
      if (!oRow) return;
      var show = Math.min(bags, 12);
      var have = oRow.querySelectorAll('.pt-calc-bag').length;
      if (show > have){
        for (var i = have; i < show; i++){
          var d = document.createElement('div');
          d.className = 'pt-calc-bag';
          oRow.appendChild(d);
          (function(el, delayIndex){
            setTimeout(function(){ el.classList.add('on'); }, reduce ? 0 : delayIndex * 60);
          })(d, i - have);
        }
      } else if (show < have){
        var nodes = oRow.querySelectorAll('.pt-calc-bag');
        for (var k = have - 1; k >= show; k--){ nodes[k].parentNode.removeChild(nodes[k]); }
      }
      var more = oRow.querySelector('.pt-calc-more');
      if (bags > 12){
        if (!more){
          more = document.createElement('div');
          more.className = 'pt-calc-more';
          more.style.cssText = 'align-self:center;color:var(--pt-muted);font-size:.9rem;font-weight:700';
          oRow.appendChild(more);
        }
        more.textContent = '+' + (bags - 12);
        oRow.appendChild(more);           // keep the marker last
      } else if (more){
        more.parentNode.removeChild(more);
      }
    }

    function calc(){
      var area = Math.max(0, parseFloat(sqft.value) || 0);
      var opt = seed.options[seed.selectedIndex];
      var rate = parseFloat(opt.getAttribute('data-rate')) || 140;
      var bagLb = parseFloat(opt.getAttribute('data-bag')) || 25;
      var price = parseFloat(opt.getAttribute('data-price')) || 0;
      /* data-rate is sq ft covered per lb AT THE NEW-LAWN RATE, matching the
         figures printed in each product's own description (e.g. SUNGOLD:
         "25 lb covers a new lawn up to 3,500 sq ft" = 140 sq ft/lb).
         Overseeding uses half the seed, so it covers twice the area.

         This previously read `area / (rate / (new ? 2 : 1))`, which treated
         the rate as an overseed figure and recommended exactly DOUBLE the
         seed in both modes. 3,500 sq ft of SUNGOLD returned 50 lb instead
         of 25 lb. Verified against the descriptions before changing. */
      var mult = (job && job.value === 'new') ? 1 : 2;
      var lbs = area / (rate * mult);
      var bags = Math.max(1, Math.ceil(lbs / bagLb));
      if (oBags) oBags.textContent = bags;
      if (oLbl) oLbl.textContent = (bags===1?'bag needed':'bags needed') + ' · about ' + (bags*bagLb) + ' lb';
      if (oCost && price) oCost.textContent = 'Estimated $' + (bags*price).toFixed(2);
      syncBags(bags);
    }
    [sqft, seed, job].forEach(function(el){ el && el.addEventListener('input', calc); });
    calc();
  });
})();
